var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKebab = function SvgKebab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.666a1.334 1.334 0 1 1 0 2.669 1.334 1.334 0 0 1 0-2.669M8 2.666a1.334 1.334 0 1 1 0 2.669 1.334 1.334 0 0 1 0-2.669M8 10.666a1.334 1.334 0 1 1 0 2.669 1.334 1.334 0 0 1 0-2.669"
  })));
};
export default SvgKebab;